import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { MaintenanceManager } from 'src/app/classes/maintenance-manager';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-maintenance-dashboard',
  templateUrl: './maintenance-dashboard.component.html',
  styleUrls: ['./maintenance-dashboard.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class MaintenanceDashboardComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  loading:boolean = false;

  chartByUnity:any;
  chartByType:any;

  mLabels;
  mDataset;

  constructor(private repServ:ReportService, private maintenanceMan:MaintenanceManager) { }

  ngOnInit() {
    this.chartByUnity = new Chart('byUnity', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'Manto Unidad'
        },
      },
    });
    this.chartByType = new Chart('byType', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'Manto Tipo'
        },
      },
    });
  }

  search() {
    this.loading = true;
    this.repServ.maintenanceReport(this.date1, this.date2)
      .then(resp => {
        this.data = this.maintenanceMan.calculate(resp);

        let uLabels = [];
        let uDataset = [];
        let tLabels = [];
        let tDataset = [];
        this.mLabels = [];
        this.mDataset = [];

        for (let i = 0; i < this.data.length; i++) {
          uLabels.push(this.data[i].info[0].unity_id);
          uDataset.push(this.data[i].totalTotal);

          for (let j = 0; j < this.data[i].info.length; j++) {
            let el = this.data[i].info[j];
            //by type
            let toUpdate = tLabels.find(e => e == el.expense_type_name);
            if (!toUpdate) {
              tLabels.push(el.expense_type_name);
              tDataset.push(Number(el.quantity) * Number(el.price) * (1 + Number(el.iva)) - Number(el.discount)/Number(el.lines));
            } else {
              tDataset[tLabels.indexOf(el.expense_type_name)] += Number(el.quantity) * Number(el.price) * (1 + Number(el.iva)) - Number(el.discount)/Number(el.lines);
            }

            //by month
            let month = el.maintenance_date.substring(0, 7);
            let toUpdate2 = this.mLabels.find(e => e == month);

            if (!toUpdate2) {//add month to header table
              this.mLabels.push(month);
            }
          }
        }

        for (let i = 0; i < this.data.length; i++) {
          for (let j = 0; j < this.data[i].info.length; j++) {
            let el = this.data[i].info[j];
            let month = el.maintenance_date.substring(0, 7);
            if (!('Unidad ' + el.unity_id in this.mDataset)) {
              this.mDataset['Unidad ' + el.unity_id] = Array(this.mLabels.length).fill(0);
              this.mDataset['Unidad ' + el.unity_id][this.mLabels.indexOf(month)] = Number(el.quantity) * Number(el.price) * (1 + Number(el.iva)) - Number(el.discount)/Number(el.lines);
            } else {
              this.mDataset['Unidad ' + el.unity_id][this.mLabels.indexOf(month)] += Number(el.quantity) * Number(el.price) * (1 + Number(el.iva)) - Number(el.discount)/Number(el.lines);
            }
          }
        }

        this.chartByUnity.data.labels = uLabels; 
        this.chartByUnity.data.datasets = [{
          label: 'Unidades',
          data: uDataset,
          backgroundColor: 'rgb(14, 34, 64)',
        }];
        this.chartByUnity.update();
        this.chartByType.data.labels = tLabels; 
        this.chartByType.data.datasets = [{
          label: 'Tipo',
          data: tDataset,
          backgroundColor: 'rgb(226, 88, 41)',
        }];
        this.chartByType.update();
        this.loading = false;
      });
  }

  total (month) {
    let index = this.mLabels.indexOf(month);
    let total = 0;
    for (let d in this.mDataset) {
      total += this.mDataset[d][index];
    }
    return total;
  }
}
